import { EventEmitter, Injectable } from '@angular/core';
import { HubConnection } from '@aspnet/signalr';
// import { HubConnection } from '@microsoft/signalr';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';

import { SettingsService } from '../../services/settings.service';
import { generateTaskId } from '../utils';
import { CreateRtcOptions, IRTCPeerConnectionSession, LivePack, LiveRoomChangeNotice, LiveRoomInfo, RtcEventArgs, RTCIceCandidateData, RTCIceDescription } from './model';

@Injectable({
  providedIn: 'root'
})
export class RtcService {

  screen_stream: MediaStream;
  camera_stream: MediaStream;
  mediaDevices = navigator.mediaDevices as any;
  rtcConnectionSessions: Array<IRTCPeerConnectionSession> = [];
  private hubConnection: HubConnection;
  private iceCandidateQueue: Array<RTCIceCandidateData> = [];

  public changeEvent: EventEmitter<RtcEventArgs>;

  constructor(public settings: SettingsService, private notification: NzNotificationService, private message: NzMessageService) {
    this.changeEvent = new EventEmitter<RtcEventArgs>();


  }

 
  setuphubConnection(conn: HubConnection) {
    this.hubConnection = conn;
    this.hubConnection.on("requestRtcConnection", (acceptUserId: string, requestUserId: string) => this.reqeustCreateConnection(acceptUserId, requestUserId));
    this.hubConnection.on("setRemoteOffer", (n: RTCIceDescription) => this.onSetRemoteOffer(n));
    this.hubConnection.on("setAnswerOffer", (n: RTCIceDescription) => this.onAnswerOffer(n));
    this.hubConnection.on("icecandidate", (n: RTCIceCandidateData) => this.addIcecandidate(n));
    this.hubConnection.on("broadcastRoomChange", (n: LiveRoomChangeNotice) => this.liveRoomChange(n));
    this.excuteAddIcecandidate();
  }

  async createRoom(opt: CreateRtcOptions, type: number) {
    this.rtcConnectionSessions = [];
    this.settings.setLiveRoomInfo("IsCreator", true);
    if (opt.camera) {
      this.camera_stream = await this.getCameraStream(opt);
      if (this.camera_stream) {
        console.log("ok camera_stream")
        this.settings.setLiveRoomInfo("Audio", opt.audio);
        this.settings.setLiveRoomInfo("Camera", opt.camera);
        this.camera_stream.getVideoTracks()[0].addEventListener('ended', (end) => {
          this.message.create('warning', "视频流已断开");
          this.settings.setLiveRoomInfo("Camera", false);
          this.settings.setLiveRoomInfo("Audio", false);
        });
        this.changeEvent.emit({ type: 'renderLocalStream', streamType: 1, stream: this.camera_stream });
      }
    }
    if (opt.screen) {
      this.screen_stream = await this.getScreenStream(opt);
      if (this.screen_stream) {
        this.settings.setLiveRoomInfo("Screen", true);
        this.screen_stream.getVideoTracks()[0].addEventListener('ended', (end) => {
          this.message.create('warning', "直播流已断开");
          this.settings.setLiveRoomInfo("Screen", false);
        });
        // this.changeEvent.emit({ type: 'renderLocalStream', streamType: 0, stream: this.screen_stream });
      }
    }
    return true;
  }

  leaveRoom(notice: boolean) {
    if (this.camera_stream) {
      this.camera_stream.getVideoTracks()[0].stop();
      this.camera_stream = null;
    }
    if (this.screen_stream) {
      this.screen_stream.getVideoTracks()[0].stop();
      this.screen_stream = null;
    }
    if (this.rtcConnectionSessions.length > 0) {
      this.rtcConnectionSessions.forEach((n, index) => {
        n.connection.close();
        this.rtcConnectionSessions.splice(index, 1);
      });
    }
    if (notice) {
      this.hubConnection.invoke("LeaveRoom").then(n => {
        this.message.create('info', "直播已结束");
      });
    } else {
      this.message.create('info', "直播已结束");
    }

    this.settings.setLiveRoomInfo("Screen", false);
    this.settings.setLiveRoomInfo("Camera", false);
    this.settings.setLiveRoomInfo("Audio", false);
    this.settings.setLiveRoomInfo("IsCreator", false);
    this.settings.setLiveRoomInfo("IsCreator", false);
    this.settings.setLiveRoomInfo("Show", false);
  }

  readyConnection(live: LiveRoomInfo) {
    var acceptUserId = live.UserId;
    var requestUserId = this.settings.user.userId;
    if (live.Screen) {
      var screenConn = this.createRTCPeerConnection(requestUserId, acceptUserId, 0);
      this.pushConnectionSession(live.UserId, screenConn, 0);
    }
    if (live.Camera) {
      var cameraConn = this.createRTCPeerConnection(requestUserId, acceptUserId, 1);
      this.pushConnectionSession(live.UserId, cameraConn, 1);
    }
    this.hubConnection.send("RequestRtcConnection", acceptUserId, requestUserId);
  }

  private async getScreenStream(opt: CreateRtcOptions) {
    try {
      const stream = await this.mediaDevices.getDisplayMedia({ video: true }) as Promise<MediaStream>;
      return stream;
    } catch (error) {
      opt.screen = false;
      if (error.name != 'NotAllowedError') {
        console.error('浏览器当前不支持getDisplayMedia功。请使用host或Https升级浏览器Google Chrome 85' + error);
      }

      this.settings.setLiveRoomInfo("Screen", false);
      return null;
    }
  }
  private async getCameraStream(opt: CreateRtcOptions) {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: opt.audio, video: opt.camera });
      return stream;
    } catch (error) {
      console.error(error.name);
      opt.audio = false;
      opt.camera = false;
      if (error.name == 'NotReadableError') {
        this.notification.create(
          'error',
          '不能启动视频设备',
          '无法使用您的媒体设备，设备被占用.'
        );
      }
      if (error.name != 'NotAllowedError') {
        this.notification.create(
          'error',
          '该功能不受支持',
          '浏览器当前不支持getUserMedia功能。请使用host或Https升级浏览器Google Chrome 85+'
        );
      }

      this.settings.setLiveRoomInfo("Camera", false);
      this.settings.setLiveRoomInfo("Audio", false);
      return null;
    }
  }

  async reqeustCreateConnection(acceptUserId: string, requestUserId: string) {
    if (this.screen_stream) {
      var screen_conn = this.createRTCPeerConnection(requestUserId, acceptUserId, 0, this.screen_stream);
      this.pushConnectionSession(requestUserId, screen_conn, 0);
      this.screen_stream.getTracks().forEach(track => screen_conn.addTrack(track, this.screen_stream));
      var des = await screen_conn.createOffer({
        offerToReceiveVideo: true,
        offerToReceiveAudio: true
      });
      await screen_conn.setLocalDescription(des);
      var data: RTCIceDescription = {
        requestUserId: acceptUserId,
        acceptUserId: requestUserId,
        des: {
          streamType: 0,
          desOffer: des
        }
      }

      await this.hubConnection.send("SendRemoteOffer", data);
    }

    if (this.camera_stream) {
      var camera_conn = this.createRTCPeerConnection(requestUserId, acceptUserId, 1, this.camera_stream);
      this.pushConnectionSession(requestUserId, camera_conn, 1);
      this.camera_stream.getTracks().forEach(track => {
        camera_conn.addTrack(track, this.camera_stream);
        console.log(`camera_conn addTrackc ${track}`)
      });
 
      var des = await camera_conn.createOffer({
        offerToReceiveVideo: true,
        offerToReceiveAudio: true
      });
      console.log(`createOffer`);
      await camera_conn.setLocalDescription(des);
      console.log(`setLocalDescription`)
      var data: RTCIceDescription = {
        requestUserId: acceptUserId,
        acceptUserId: requestUserId,
        des: {
          streamType: 1,
          desOffer: des
        }
      }

      await this.hubConnection.send("SendRemoteOffer", data);
    }
  }

  private pushConnectionSession(userId: string, connection: RTCPeerConnection, streamType: number) {
    var index = this.rtcConnectionSessions.findIndex(n => n.userId == userId && n.streamType == streamType);
    if (index != -1) {
      this.rtcConnectionSessions[index].connection.close();
      this.rtcConnectionSessions.splice(index, 1);
    }

    console.log(this.rtcConnectionSessions)
    this.rtcConnectionSessions.push({ userId, connection, streamType });
  }
  async onSetRemoteOffer(n: RTCIceDescription) {
    var userId = n.requestUserId;
    const offer = n.des;
    var conn = this.rtcConnectionSessions.find(c => c.userId == userId && c.streamType == offer.streamType).connection;
    await conn.setRemoteDescription(offer.desOffer);
    console.log(`setRemoteDescription`);
    const answer = await conn.createAnswer();
    await conn.setLocalDescription(answer);
    console.log(`setLocalDescription`);
    var des: RTCIceDescription = {
      requestUserId: n.acceptUserId,
      acceptUserId: n.requestUserId,
      des: {
        streamType: n.des.streamType,
        desOffer: answer
      }
    };
    console.log(`SendAnswerOffer`);
    this.hubConnection.invoke("SendAnswerOffer", des);
  }

  private createRTCPeerConnection(acceptUserId: string, requestUserId: string, streamType: number, stream?: MediaStream) {
    var conn = new RTCPeerConnection();
    conn.addEventListener('icecandidate', e => this.onIcecandidate(acceptUserId, requestUserId, streamType, e));
    conn.addEventListener('track', e => this.renderRemoveStream(streamType, e));
    conn.addEventListener('connectionstatechange', e => this.onConnectionStateChange(e, streamType));
    console.log(`createRTCPeerConnection`);
    return conn;
  }

  private async onAnswerOffer(answer: RTCIceDescription) {
    var conn = this.rtcConnectionSessions.find(n => n.userId == answer.requestUserId && n.streamType == answer.des.streamType).connection;
    await conn.setRemoteDescription(answer.des.desOffer);
    console.log(`onAnswerOffer setRemoteDescription`);
  }

  private onConnectionStateChange(e: Event, streamType: number) {
    var index = this.rtcConnectionSessions.findIndex(m => m.connection == e.target);
    if (index == -1) { return; }
    var conn = this.rtcConnectionSessions[index].connection;
    if (conn.iceConnectionState === "failed" ||
      conn.iceConnectionState === "disconnected" ||
      conn.iceConnectionState === "closed") {
      // Handle the failure
      this.rtcConnectionSessions[index].connection.close();
      this.rtcConnectionSessions.splice(index, 1);
    }

    console.log(this.rtcConnectionSessions);
  }
  private async onIcecandidate(acceptUserId: string, issueUserId: string, streamType: number, e: RTCPeerConnectionIceEvent) {
    if (!e.candidate) {
      return;
    }
    var data: RTCIceCandidateData = {
      acceptUserId: acceptUserId,
      requestUserId: issueUserId,
      streamType: streamType,
      candidate: e.candidate
    }
    console.log(`ICE candidate:\n${e.candidate ? e.candidate.candidate : '(null)'}`);
    await this.hubConnection.send("SendIcecandidate", data);
  }

  addIcecandidate(data: RTCIceCandidateData) {
    // setTimeout(() => {
    //   var getCnn = this.rtcConnectionSessions.find(m => m.userId == data.requestUserId && m.streamType == data.streamType);
    //   getCnn.connection.addIceCandidate(data.candidate);
    //  }, 100);
   console.log("addIcecandidate to iceCandidateQueue")
    this.iceCandidateQueue.push(data);
  }

  excuteAddIcecandidate() {
    for (let index = 0; index < this.iceCandidateQueue.length; index++) {
      var data = this.iceCandidateQueue[index];
      var getCnn = this.rtcConnectionSessions.find(m => m.userId == data.requestUserId && m.streamType == data.streamType);
      if (getCnn && getCnn.connection.remoteDescription && getCnn.connection.localDescription) {
        console.log("-------------------addIcecandidate-------------")
        console.log(data)
        console.log("-------------------addIcecandidate-------------")
        getCnn.connection.addIceCandidate(data.candidate);
        this.iceCandidateQueue.splice(index, 1);
      }

    }
  
    setTimeout(() => { this.excuteAddIcecandidate(); }, 50);
  }
  //执行队列添加到候选人链接
  // excuteAddIcecandidate(){

  //   this.iceCandidateQueue.forEach(data=>{
  //     var getCnn = this.rtcConnectionSessions.find(m => m.userId == data.requestUserId && m.streamType == data.streamType)
  //     console.log("-------------------addIcecandidate-------------")
  //     console.log(data)
  //     console.log("-------------------addIcecandidate-------------")
  //     getCnn.connection.addIceCandidate(data.candidate);

  //   });
  //   this.iceCandidateQueue=[];
  // }

  private renderRemoveStream(streamType: number, e: RTCTrackEvent) {
    console.log(`renderRemoveStream.........${e.streams}`)
    this.changeEvent.emit({
      type: 'renderRemoveStream',
      streamType: streamType,
      stream: e
    });
  }

  private liveRoomChange(e: LiveRoomChangeNotice) {
    if (e.Type == 0) {

    } else if (e.Type == 1) {

    } else if (e.Type == 2) {

      this.updateMediaStatus(e);
    } else if (e.Type == 3) {
      this.leaveRoom(false);
    }

  }
  public toggleScreen() {
    var opt = { audio: this.settings.liveInfo.Audio, screen: true, camera: this.settings.liveInfo.Camera };
    opt.screen = !this.settings.liveInfo.Screen;
    this.settings.setLiveRoomInfo('Screen', opt.screen);
    this.screen_stream.getVideoTracks()[0].enabled = opt.screen;
    this.sendMediaStatus();
  }

  public toggleCamera() {
    var opt = { audio: this.settings.liveInfo.Audio, screen: true, camera: this.settings.liveInfo.Camera };
    opt.camera = !this.settings.liveInfo.Camera;
    this.settings.setLiveRoomInfo('Camera', opt.camera);
    this.camera_stream.getVideoTracks()[0].enabled = opt.camera;
    this.sendMediaStatus();
  }
  public toggleAudio() {
    var opt = { audio: this.settings.liveInfo.Audio, screen: true, camera: this.settings.liveInfo.Camera };
    opt.audio = !this.settings.liveInfo.Audio;
    this.settings.setLiveRoomInfo('Audio', opt.audio);
    this.camera_stream.getAudioTracks()[0].enabled = opt.audio;
    this.sendMediaStatus();

  }

  public toggleSendMessage() {
    var status = !this.settings.liveInfo.BanMessage;
    this.settings.setLiveRoomInfo('BanMessage', status);
    this.sendMediaStatus();
  }

  private sendMediaStatus() {
    var pack: LiveRoomChangeNotice = {
      Type: 2,
      NoticeUserId: this.settings.user.UserId,
      RoomId: this.settings.liveInfo.RoomId ?? 1,
      RoomGroupId: this.settings.liveInfo.RoomGroupId ?? '36ACC490-9D10-4DAC-8282-450A2F080276',
      Status: this.settings.liveInfo.Status,
      Camera: this.settings.liveInfo.Camera,
      Audio: this.settings.liveInfo.Audio,
      Screen: this.settings.liveInfo.Screen,
      BanMessage: this.settings.liveInfo.BanMessage
    };
    this.hubConnection.send("UpdateRoomStatusAsync", pack);
  }

  private updateMediaStatus(e: LiveRoomChangeNotice) {
    if (e.BanMessage != this.settings.liveInfo.BanMessage) {
      var title = e.BanMessage ? '开启禁言' : '取消禁言'
      this.message.info("房间已" + title);
      this.settings.liveInfo.BanMessage = e.BanMessage;
    }
    if (e.Audio != this.settings.liveInfo.Audio) {
      var title = e.Audio ? '开启麦克风' : '关闭麦克风';
      this.message.info(`房间已 ` + title);

    }

    if (e.Camera != this.settings.liveInfo.Camera) {
      var title = e.Camera ? '开启摄像头' : '关闭摄像头';
      this.message.info(`房间已 ` + title);

    }

    if (e.Screen != this.settings.liveInfo.Screen) {
      var title = e.Screen ? '开启屏幕共享' : '关闭屏幕共享';
      this.message.info(`房间已 ` + title);

    }
  }


}
